<template>
  <svg
    width="996"
    height="1027"
    viewBox="0 0 996 1027"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_8007_12754)">
      <ellipse
        cx="90.3981"
        cy="121.44"
        rx="90.3981"
        ry="121.44"
        transform="matrix(-0.866025 -0.5 -0.5 0.866025 637.014 453.398)"
        fill="#A370F7"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_8007_12754"
        x="0.717621"
        y="0.658295"
        width="994.578"
        height="1025.42"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="199.105"
          result="effect1_foregroundBlur_8007_12754"
        />
      </filter>
    </defs>
  </svg>
</template>
